/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};






/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2006, 2014 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD (Register as an anonymous module)
		define(['jquery'], factory);
	} else if (typeof exports === 'object') {
		// Node/CommonJS
		module.exports = factory(require('jquery'));
	} else {
		// Browser globals
		factory(jQuery);
	}
}(function ($) {

	var pluses = /\+/g;

	function encode(s) {
		return config.raw ? s : encodeURIComponent(s);
	}

	function decode(s) {
		return config.raw ? s : decodeURIComponent(s);
	}

	function stringifyCookieValue(value) {
		return encode(config.json ? JSON.stringify(value) : String(value));
	}

	function parseCookieValue(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape...
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}

		try {
			// Replace server-side written pluses with spaces.
			// If we can't decode the cookie, ignore it, it's unusable.
			// If we can't parse the cookie, ignore it, it's unusable.
			s = decodeURIComponent(s.replace(pluses, ' '));
			return config.json ? JSON.parse(s) : s;
		} catch(e) {}
	}

	function read(s, converter) {
		var value = config.raw ? s : parseCookieValue(s);
		return $.isFunction(converter) ? converter(value) : value;
	}

	var config = $.cookie = function (key, value, options) {

		// Write

		if (arguments.length > 1 && !$.isFunction(value)) {
			options = $.extend({}, config.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
			}

			return (document.cookie = [
				encode(key), '=', stringifyCookieValue(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// Read

		var result = key ? undefined : {},
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling $.cookie().
			cookies = document.cookie ? document.cookie.split('; ') : [],
			i = 0,
			l = cookies.length;

		for (; i < l; i++) {
			var parts = cookies[i].split('='),
				name = decode(parts.shift()),
				cookie = parts.join('=');

			if (key === name) {
				// If second argument (value) is a function it's a converter...
				result = read(cookie, value);
				break;
			}

			// Prevent storing a cookie that we couldn't decode.
			if (!key && (cookie = read(cookie)) !== undefined) {
				result[name] = cookie;
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		// Must not alter options, thus extending a fresh object...
		$.cookie(key, '', $.extend({}, options, { expires: -1 }));
		return !$.cookie(key);
	};

}));




/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}







// Virginia Stone Functions
window.vstone = window.vstone || {};




vstone.cacheSelectors = function () {
	vstone.cache = {
		// General
		$html				: $('html'),
		$body				: $('body'),
		$header				: $('#header'),
		$main				: $('#main'),
		$footer				: $('#footer'),
		
		
		
		$footerWrap			: $('.footer-wrap'),
		
		
		$content			: $('.content'),

		
		//$scrollNav			: $('#scrollnav'),
		
		$slideNav			: $('.slide-nav'),
		
		//$nicescrollCursors		: $('.nicescroll-cursors'),
		
		
		$sectionBackground		: $('.section-background'),
		// Navigation
		//$navigation              : $('#AccessibleNav'),
		//$mobileSubNavToggle      : $('.mobile-nav__toggle'),
		
		$menuButton			: $('#menu-btn'),
		$overlay			: $('#overlay'),
		
		//$subMenuToggle			: $('.sub-menu-toggle','#main-menu'),
		$subMenuToggle			: $('.sub-menu-toggle'),
		
		
		
		
		

		// Collection Pages
		$changeView			: $('.change-view'),

		// Product Page
		$productImage			: $('#ProductPhotoImg'),
		$thumbImages			: $('#ProductThumbs').find('a.product-single__thumbnail'),

		// Customer Pages
		$recoverPasswordLink		: $('#RecoverPassword'),
		$hideRecoverPasswordLink	: $('#HideRecoverPasswordLink'),
		$recoverPasswordForm		: $('#RecoverPasswordForm'),
		$customerLoginForm		: $('#CustomerLoginForm'),
		$passwordResetSuccess		: $('#ResetSuccess'),
		$customerLogoutLink		: $('#customer_logout_link')
	};
};

vstone.cacheEnvironment = function () {
	vstone.environment = {
		
		touch				: vstone.cache.$html.hasClass('touch') ? true : false
	//	$test :
		//	if(1==1) {
		//		console.log('Okay to here');
		//	}
	};
	
	//console.log('HAS TOUCH: ' + vstone.environment.touch);
};

vstone.init = function () {
	FastClick.attach(document.body);
	vstone.cacheSelectors();
	vstone.cacheEnvironment();
	
	vstone.initPageReveals();
	
	
	vstone.drawersInit(); // MOVED THIS DOWN TO MINE SO IT COULD BE LAST... MERGE IT ALL IN RIGHT ORDER LATER
	//vstone.mobileNavToggle();
	vstone.productImageSwitch();
	vstone.responsiveVideos();
	vstone.collectionViews();
	vstone.loginForms();
	vstone.accordions();
};

vstone.menuButtonOpensMenu = function() {
	//console.log('Menu button opens menu.');
	//vstone.enableScrolling();
	vstone.cache.$menuButton.off().on('click', function(evt) {
		evt.stopPropagation();
		vstone.MenuDrawer.open();
		vstone.menuDrawerOpen();
		//vstone.menuButtonClosesMenu();
	});
	//vstone.cache.$overlay.off();
}

vstone.menuButtonClosesMenu = function() {
	//console.log('Menu button closes menu.');
	vstone.cache.$menuButton.off().on('click', function(evt) {
		evt.stopPropagation();
		vstone.MenuDrawer.close();
		//vstone.enableScrolling();
		//vstone.menuButtonOpensMenu();
	});
}

vstone.menuButtonClosesCart = function() {
	//console.log('Menu button closes cart.')
	//vstone.enableScrolling();
	vstone.cache.$menuButton.off().on('click', function(evt) {
		evt.stopPropagation();
		vstone.CartDrawer.close();
		//vstone.enableScrolling();
		//vstone.menuButtonOpensMenu();
	});
}

vstone.menuDrawerOpen = function() {
	//console.log('Menu drawer open.');
	//vstone.disableScrolling();
	//vstone.menuButtonClosesMenu();
	vstone.cache.$menuButton.off().on('click', function(evt) {
		evt.stopPropagation();
		vstone.MenuDrawer.close();
		//vstone.menuButtonOpensMenu();
	});
	//vstone.cache.$overlay.off().on('click', function() {
	//	vstone.MenuDrawer.close();
	//	vstone.menuButtonOpensMenu();
	//});
}

vstone.cartDrawerOpen = function() {
	//console.log('Cart drawer open.');
	//vstone.disableScrolling();
	//vstone.menuButtonClosesCart();
	vstone.cache.$menuButton.off().on('click', function(evt) {
		evt.stopPropagation();
		vstone.CartDrawer.close();
		//vstone.menuButtonOpensMenu();
	});
	//vstone.cache.$overlay.off().on('click', function() {
	//	vstone.CartDrawer.close();
	//	vstone.menuButtonOpensMenu();
	//});
}

vstone.drawersInit = function () {
	//vstone.MenuDrawer = new vstone.Drawers('main-menu', 'menu', {
	//	'onDrawerOpen': vstone.menuDrawerOpen
	//});
	//vstone.menuButtonOpensMenu();
	vstone.MenuDrawer = new vstone.Drawers('main-menu', 'menu');
	vstone.CartDrawer = new vstone.Drawers('CartDrawer', 'cart', {
		'onDrawerOpen': ajaxCart.load
		//'onDrawerOpen': vstone.cartDrawerOpen
	});
};

// may be able to reuse these functions in places where i wrote similar code later on
vstone.getHash = function () {
	return window.location.hash;
};

vstone.updateHash = function (hash) {
	window.location.hash = '#' + hash;
	$('#' + hash).attr('tabindex', -1).focus();
};

vstone.productPage = function (options) {

	//console.log('productPage function called.');
  
	var moneyFormat = options.money_format,
	variant = options.variant,
	selector = options.selector;

	// Selectors
	var $productImage = $('#ProductPhotoImg'),
	$addToCart = $('#AddToCart'),
	$addToCartWH = $('#AddToCartWH'),
	$productPrice = $('#ProductPrice'),
	$comparePrice = $('#ComparePrice'),
	$quantityElements = $('.quantity-selector, label + .js-qty'),
	$addToCartText = $('#AddToCartText');

	if (variant) {

		// Update variant image, if one is set
		if (variant.featured_image) {
			var newImg = variant.featured_image,
			el = $productImage[0];
			Shopify.Image.switchImage(newImg, el, vstone.switchImage);
		}

		// Select a valid variant if available
		if (variant.available) {
			// Available, enable the submit button, change text, show quantity elements
			$addToCart.removeClass('disabled').prop('disabled', false);
			$addToCartWH.removeClass('disabled').prop('disabled', false);
			$addToCartText.html("Add to Cart");
			//$productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );
			//$quantityElements.show();
		} else {
			// Sold out, disable the submit button, change text, hide quantity elements
			$addToCart.addClass('disabled').prop('disabled', true);
			$addToCartWH.addClass('disabled').prop('disabled', true);
			$addToCartText.html("Out of Stock");
			//$productPrice.html("Out of Stock");
			//$quantityElements.hide();
		}

		// Regardless of stock, update the product price
		$productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );
	
		// Also update and show the product's compare price if necessary
		if (variant.compare_at_price > variant.price) {
			$comparePrice
			//.html("Regular" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
			.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
			.show();
		} else {
			$comparePrice.hide();
		}

	} else {
		// The variant doesn't exist, disable submit button.
		// This may be an error or notice that a specific variant is not available.
		// To only show available variants, implement linked product options:
		//   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
		$addToCart.addClass('disabled').prop('disabled', true);
		$addToCartText.html("Unavailable");
		$quantityElements.hide();
	}
};

vstone.productImageSwitch = function () {
	if (vstone.cache.$thumbImages.length) {
		// Switch the main image with one of the thumbnails
		// Note: this does not change the variant selected, just the image
		vstone.cache.$thumbImages.on('click', function(evt) {
			evt.preventDefault();
			var newImage = $(this).attr('href');
			//var newZoomImage = $(this).next('img').attr('href');
			//console.log(newZoomImage);
			vstone.switchImage(newImage, null, vstone.cache.$productImage);
			//vstone.switchImage(newZoomImage, null, vstone.cache.$productImage);
		});
	}
};

vstone.switchImage = function (src, imgObject, el) {
	
	// Make sure element is a jquery object
	var $el = $(el);
	$el.attr('src', src);
	
	// Update zoom image
	$zoomImg = $el.next('.zoomImg');
	$zoomImg.attr('src', src);
	
};

vstone.responsiveVideos = function () {
	var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
	var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

	$iframeVideo.each(function () {
		// Add wrapper to make video responsive
		$(this).wrap('<div class="video-wrapper"></div>');
	});

	$iframeReset.each(function () {
		// Re-set the src attribute on each iframe after page load
		// for Chrome's "incorrect iFrame content on 'back'" bug.
		// https://code.google.com/p/chromium/issues/detail?id=395791
		// Need to specifically target video and admin bar
		this.src = this.src;
	});
};

vstone.collectionViews = function () {
	if (vstone.cache.$changeView.length) {
		vstone.cache.$changeView.on('click', function() {
			var view = $(this).data('view'),
			url = document.URL,
			hasParams = url.indexOf('?') > -1;

			if (hasParams) {
				window.location = replaceUrlParam(url, 'view', view);
			} else {
				window.location = url + '?view=' + view;
			}
		});
	}
};

vstone.loginForms = function() {
	function showRecoverPasswordForm() {
		vstone.cache.$recoverPasswordForm.show();
		vstone.cache.$customerLoginForm.hide();
	}

	function hideRecoverPasswordForm() {
		vstone.cache.$recoverPasswordForm.hide();
		vstone.cache.$customerLoginForm.show();
	}

	vstone.cache.$recoverPasswordLink.on('click', function(evt) {
		evt.preventDefault();
		showRecoverPasswordForm();
	});

	vstone.cache.$hideRecoverPasswordLink.on('click', function(evt) {
		evt.preventDefault();
		hideRecoverPasswordForm();
	});

	// Allow deep linking to recover password form
	if (vstone.getHash() == '#recover') {
		showRecoverPasswordForm();
	}
};

vstone.resetPasswordSuccess = function() {
	vstone.cache.$passwordResetSuccess.show();
};




/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
vstone.Drawers = (function () {
	var Drawer = function (id, position, options) {
		var defaults = {
			close: '.drawer-close',
			//close:	'#menu-btn',
			open: '.drawer-open-' + position,
			//open: '.drawer-open',
			openClass: 'drawer-open',
			dirOpenClass: 'drawer-open-' + position
			//dirOpenClass: 'drawer-open'
		};

		this.$nodes = {
			parent: $('body, html'),
			page: $('#overlay'), // GOTTA CHANGE TO OVERLAY, AND THEN LAYER IN MY STUFF
			moved: $('.is-moved-by-drawer')
		};

		this.config = $.extend(defaults, options);
		this.position = position;

		this.$drawer = $('#' + id);

		if (!this.$drawer.length) {
			return false;
		};

		this.drawerIsOpen = false;
		this.init();
	};

	Drawer.prototype.init = function () {
		$(this.config.open).on('click', $.proxy(this.open, this));
		//this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
		//$(this.config.close).off().on('click', $.proxy(this.close, this));
	
	
		//vstone.cache.$menuButton.off().on('click', $.proxy(this.close, this));
		
		
	};

	Drawer.prototype.open = function (evt) {
		// Keep track if drawer was opened from a click, or called by another function
		var externalCall = false;

		// Prevent following href if link is clicked
		if (evt) {
			evt.preventDefault();
		} else {
			externalCall = true;
		}

		// Without this, the drawer opens, the click event bubbles up to $nodes.page
		// which closes the drawer.
		if (evt && evt.stopPropagation) {
			evt.stopPropagation();
			// save the source of the click, we'll focus to this on close
			this.$activeSource = $(evt.currentTarget);
		}

		if (this.drawerIsOpen && !externalCall) {
			return this.close();
		}

		// Add is-transitioning class to moved elements on open so drawer can have
		// transition for close animation
		this.$nodes.moved.addClass('is-transitioning');
		this.$drawer.prepareTransition();

		this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
		this.drawerIsOpen = true;

		// Set focus on drawer
		this.trapFocus(this.$drawer, 'drawer_focus');

		// Run function when draw opens if set
		if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
			if (!externalCall) {
				this.config.onDrawerOpen();
			}
		}

		if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
			this.$activeSource.attr('aria-expanded', 'true');
		}

		// Lock scrolling on mobile
		this.$nodes.page.on('touchmove.drawer', function () {
			return false;
		});

		this.$nodes.page.on('click.drawer', $.proxy(function () {
			this.close();
			//vstone.menuButtonOpensMenu();
			
			return false;
		}, this));
		
		
		//vstone.cache.$menuButton.off().on('click', this.close());
		
		//vstone.disableScrolling();
		
	};

	Drawer.prototype.close = function () {
		if (!this.drawerIsOpen) { // don't close a closed drawer
			return;
		}

		// deselect any focused form elements
		$(document.activeElement).trigger('blur');

		// Ensure closing transition is applied to moved elements, like the nav
		this.$nodes.moved.prepareTransition({ disableExisting: true });
		this.$drawer.prepareTransition({ disableExisting: true });

		this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

		this.drawerIsOpen = false;

		// Remove focus on drawer
		this.removeTrapFocus(this.$drawer, 'drawer_focus');

		this.$nodes.page.off('.drawer');
		
		//vstone.enableScrolling();
		vstone.menuButtonOpensMenu();
		
	};

	Drawer.prototype.trapFocus = function ($container, eventNamespace) {
		var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

		$container.attr('tabindex', '-1');

		$container.focus();

		$(document).on(eventName, function (evt) {
			if ($container[0] !== evt.target && !$container.has(evt.target).length) {
				$container.focus();
			}
		});
	};

	Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
		var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

		$container.removeAttr('tabindex');
		$(document).off(eventName);
	};

	return Drawer;
})();

// Initialize Timber's JS on docready
$(vstone.init);
















/* Set Some Vars */
//var isMobile		= $.browser.mobile;
//var isDesktop		= $.browser.desktop;


var isMobile;
var isDesktop;
var hasTouch;
var hasScrollify;
var allowScrollify;
var scrollifyEnabled;
var templateShop;
var isBGVideoSafe;
//var hasNicescroll;
//var hasScrollNav;






var hasNiceScroll = false;
var videoPaused = false;




//var enhancedUI = false;



var mediumViewport = false;
var mediumWidth = false;





vstone.resizeHandler = function() {
	//console.log('Resize handler called.');
	
	vstone.isMinRes('landscape',768,480) ? mediumViewport = true : mediumViewport = false;
	//console.log('Is medium viewport: ' + mediumViewport);
	
	vstone.isMinRes('width',768) ? mediumWidth = true : mediumWidth = false;
	//console.log('Is medium viewport width: ' + mediumWidth);
	
	if(scrollifyEnabled) {
		//console.log('Page has scrollify.');
		if(isDesktop && mediumViewport) {
			if(scrollifyEnabled) {
				//console.log('Scrollify is already enabled.');
			} else {
				//$.scrollify.enable();
				//$.scrollify.update();
				//scrollifyEnabled = true;
				//console.log('Re-enabling scrollify.');
			}
		} else {
			if(scrollifyEnabled) {
				//$.scrollify.disable();
				//scrollifyEnabled = false;
				//console.log('Disabling scrollify.');
			}
		}
	} else if (hasScrollify) {
		
		
		vstone.cache.$header.length ? headerHeight = vstone.cache.$header.height() : headerHeight = 0;
		$('#scrollnav').length ? scrollNavHeight = $('#scrollnav').height() : scrollNavHeight = 0;
		offsetHeight = headerHeight + scrollNavHeight;
			
		//console.log('Offset height: ' + offsetHeight);
			
		$('.section').css('height',$(window).height() - offsetHeight);
			

	}
	

	
	console.log('Resize handler... Scrollify enabled: ' + scrollifyEnabled);
	
}

/* Background Video Safe */
//vstone.videoBGSafe = function() {
	//return (isDesktop) ? true : false;
//}

/* Initiate Background Video */
vstone.initBGVideo = function() {
	
	// Add background video code to page
	//var videoHTML = $('<div id="bg-video" class="player" data-property="{videoURL:\'https://youtu.be/aSDA5MZlPYk\', ratio:\'16/9\', containment:\'#page-home\', showControls:true, autoPlay:false, loop:false, vol:80, mute:false, startAt:0, opacity:1, addRaster:false, quality:\'hd720\', optimizeDisplay:true}"></div>');
	//$('body').append(videoHTML);
		
	// Kick off video vars
	vstone.loadBGVideo();
		
}

/* Mobile Video */
vstone.initMobileVideo = function() {
		
	// Remove desktop-only sections
	//$('.desktop').remove();
		
	// Add overlay and video code here
		
}

vstone.winW = function() {
	//console.log('Window width function called and it is: ' + window.innerWidth)
	return window.innerWidth;
	
}

vstone.winH = function() {
	//console.log('Window height function called and it is: ' + window.innerHeight)
	//return window.innerHeight;

	
	var height = (window.innerHeight?window.innerHeight:document.documentElement&&document.documentElement.clientHeight?document.documentElement.clientHeight:document.body.clientHeight);
	//console.log('Window height: ' + height);
	return height;
}

vstone.isMinRes = function(orientation,w,h) {
	
	var isMinRes;
	switch(orientation) {
		
		case 'either':
			isMinRes = (vstone.winW() >= w && vstone.winH() >= h) || (vstone.winW() >= h && vstone.winH() >= w) ? true : false;
			break;
		
		case 'landscape':
			isMinRes = (vstone.winW() >= w && vstone.winH() >= h) ? true : false;
			break;
		
		case 'portrait':
			isMinRes = (vstone.winW() >= h && vstone.winH() >= w) ? true : false;
			break;
		
		case 'width':
			isMinRes = (vstone.winW() >= w) ? true : false;
			break;
		
		default :
			isMinRes = (vstone.winW() >= w) ? true : false;
	}
	return isMinRes;

}







vstone.checkSVG = function() {
	if(!Modernizr.svg) {
		$('img[src*="svg"]').attr('src', function() {
			return $(this).attr('src').replace('.svg', '.png');
		});
	}
}




vstone.disableScrolling = function() {
	//console.log('Disable scrolling called.');
//	if(hasScrollify) {
//		$.scrollify.disable();
//		scrollifyEnabled = false;
//		console.log('Scrollify disabled.');
//	}
	//if(hasNiceScroll) $('body').getNiceScroll().hide();
	
	//var niceScroll = $('body').getNiceScroll()[0];
	//niceScroll.locked = true;
	niceScroll.hide();
	//niceScroll({enablemousewheel: false});
	//$('body').niceScroll({enablemousewheel: false})
	
	
	//niceScroll.remove();
	
	//console.log('var niceScroll = ' + niceScroll);
	
	//$('body').niceScroll({cursorcolor: "#00F"});
	
	//if(hasNiceScroll) $('body').getNiceScroll().remove();
	
	
	//if(hasNiceScroll) $('html').getNiceScroll().stop();
//	console.log('Has scrollify: ' + hasScrollify);
//	console.log('Has nice scroll: ' + hasNiceScroll);
	
	//alert('Has nice scroll: ' + hasNiceScroll);
	
//	var $sectionCurrent = $('.section-current');
	//var $sectionCurrentID = '#' + $sectionCurrent.attr('id');
	
//	console.log('Current section exists: ' + $sectionCurrent.length);
	//console.log('Current section id: ' + $sectionCurrentID)
	
	
	// ERROR WHEN NO .section-current
//	$(window).on('resize.sectionTop', function() {
//		console.log('Binding window top.');
//		if ($sectionCurrent.length) {
//			console.log('There is a current section.');
//			$('body, html').scrollTop($('.section-current').offset().top);
//			//$.scrollify.instantMove($sectionCurrentID);
//		}
//	});
	
	//console.log('Current section is: ' + $sectionCurrent.attr('id'));
	
	
	
	//var lastAnimation = 0;
	//var animationTime = 700;
	//var quietPeriod = 300;
	
	// Handle mousewheel event with jquery mousewheel cross browser plugin
	//$(document).on('mousewheel', function(e) {
	//	var timeNow = new Date().getTime();
	//	if(timeNow - lastAnimation < quietPeriod + animationTime || $('body').hasClass('menu-open')) {
	//		return;
	//	}
	//	console.log('Document mousewheel scrolled!');
	//	return false;
	//});
	
//	$(document).on('mousewheel.disableScroll', function() {
//		console.log('Document mousewheel scrolled!');
//		return false;
//	});
	
	
	//$('html,body').on('touchmove',function(e){
	//	alert('Touched');
	//	e.preventDefault();
	//});
	
	//$('body').on("touchmove", false);
	
	//$('html,body').swipe({
	//	swipe:function(event, direction, distance, duration, fingerCount) {
	//		event.preventDefault();
	//	}
	//});
	
	//$('html').css('overflow','hidden');
	//$('html, body').addClass('overflow-hidden');
	
	
	
	//document.addEventListener("touchmove", function(e) { e.preventDefault() });
	
	//$('body').delegate('#main','touchmove',function(e){
	//	e.preventDefault();
	//}).delegate('#main-menu','touchmove',function(e){
	//	e.stopPropagation();
	//});
	
	//document.addEventListener('touchmove', function(e){e.preventDefault()}, false);
	
	// Best yet... but can't scroll on iphone small window AND only works without nicescroll
//	$('body,html').on('touchmove.disable', function(e){e.preventDefault()}, false);
	//$(document).on('touchmove.disable', function(e){e.preventDefault()}, false);
//	$('#main-menu').on('touchmove.disable', function(e){e.stopPropagation()}, false);
	//$('#main').on('touchmove.disable', function(e){e.preventDefault()}, false);
	
	//$(window).on('scroll.disable', function(e){e.preventDefault()}, false);
	
	//$(document).on('touchmove.disable', function(e) {
	//	if(!$('#main-menu').has($(e.target)).length) {
	//		e.preventDefault()
	//	}
		
	//}, false);
	
	
	//$(window).delegate(document,'touchmove',function(e){

    //e.preventDefault();

//}).delegate('.menu-wrap','touchmove',function(e){

   // e.stopPropagation();

//});
	
	//document.addEventListener('touchmove', function(e){e.preventDefault()}, false);
	//document.getElementById('main-menu').addEventListener('touchmove', function(e){e.stopPropagation()}, false);
	
	
}

vstone.enableScrolling = function() {
	// Add condition for whether page has scrollifying at all?
	//console.log('Has scrollify: ' + hasScrollify);
//	if(hasScrollify) {
//		$.scrollify.enable();
//		scrollifyEnabled = true;
		//$.scrollify.update();
//	}
	//$('body').getNiceScroll().show();
	
	
	//niceScroll.locked = false;
//	niceScroll.show();
	
//	$(window).off('resize.sectionTop');
	
	//$(document).off('mousewheel.disableScroll');
	
	
	
	//$('body').niceScroll({cursorcolor: "#f00"});
	
	
	//$('html').removeClass('overflow-hidden');
	
//	$(document).off('touchmove.disable');
//	$('body,html').off('touchmove.disable');
//	$('#main-menu').off('touchmove.disable');
	
	//document.removeEventListener('touchmove', function(e){e.preventDefault()}, false);
	//document.getElementById('main-menu').removeEventListener('touchmove', function(e){e.stopPropagation()}, false);
	
	
}

//vstone.openMenu = function() {
//	$('body').addClass('js-drawer-open js-menu-open');
//	vstone.disableScrolling();
	//$btnMenu.addClass('menu-open');
//}
//vstone.closeMenu = function() {
	//$('body').removeClass('js-drawer-open js-menu-open');
	
//	vstone.cache.$body.removeClass('drawer-open drawer-open-cart drawer-open-menu');
	
//	vstone.enableScrolling();
	//$btnMenu.removeClass('menu-open');
//}

//vstone.closeDrawer = function() {
//	vstone.cache.$body.removeClass('drawer-open drawer-open-cart drawer-open-menu');
	
//	vstone.enableScrolling();
	
//}

//vstone.toggleMenu = function() {
	//$('body').hasClass('js-menu-open') ? vstone.closeMenu() : vstone.openMenu();
	
//	vstone.cache.$body.toggleClass('drawer-open menu-open');
//}

vstone.playVideo = function() {
	//console.log('Play video function called.');
	$('#video-msg').removeClass('blink').html('');
	$('#video-msg-wrap').hide();
	$('#video-current').YTPPlay();
}

vstone.pauseVideo = function() {
	//console.log('Pause function called');
	//console.log('Video is currently paused: ' + videoPaused);
	if(videoPaused) {
		$('#video-current').YTPPlay();
		videoPaused = false;
	} else {
		$('#video-current').YTPPause();
		videoPaused = true;
	}
	
}

vstone.exitVideo = function() {		
	//console.log('Exit video function called.');
	$('#video-current').YTPPause();
	vstone.cache.$body.removeClass('video-open');	
	//vstone.cache.$menuButton.off('click').on('click', vstone.toggleMenu); //NEEDS BINDING TO NEW FUNCTION UP TOP
	vstone.menuButtonOpensMenu();
	//window.setTimeout(function() {
	//		$('#video-current').YTPStop();
	//}, 1000);
	
	vstone.enableScrolling();
	
}

/* Load Background Video */
vstone.loadBGVideo = function() {

		var $container = $('#video-container');

		vstone.cache.$body.append('<div id="video-container"><div id="video-msg-wrap"><div id="video-msg"></div></div></div>');

		$('.play-video').click(function(e) {
			e.preventDefault();
			vstone.disableScrolling();
			
			$('#video-msg-wrap').show();
			
			$('#video-msg').addClass('blink').html('Loading...');
			
			var videoURL = $(this).attr('href');
			
			if (!$('#video-current').length) {
				vstone.cache.$body.append('<div id="video-current" class="player"></div>');
				$('#video-current').YTPlayer ({
					videoURL: videoURL,
					containment: '#video-container',
					ratio: '16/9',
					showControls: true,
					autoPlay: false,
					loop: false,
					vol: 20,
					mute: false,
					startAt: 0,
					opacity: 1,
					addRaster: false,
					quality: 'hd720',
					optimizeDisplay: true,
					showYTLogo: false,
					onReady: function() {
						window.setTimeout(function() {
							vstone.playVideo();
						}, 1000);
					}
				});
			} else {
				$('#video-current').YTPChangeMovie({videoURL: videoURL});
			}


			
			vstone.cache.$body.addClass('video-open');
			//vstone.disableScrolling();
			vstone.cache.$menuButton.off('click').on('click', vstone.exitVideo);

			
			
			
			
			
		});
		
		
		
		vstone.cache.$body.delegate('#wrapper_mbYTP_video-current', 'click', vstone.pauseVideo);
		
};

/* Local scroll */
vstone.localScroll = function() {

	//console.log('Local scroll initiated.');
	
	$('a[href*=#]:not(.accordion-title):not([href=#])').off().on('click', function(e) {
		console.log('Local scroll click.');
		e.preventDefault();
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				//if(scrollifyEnabled) {
					// Use scrollify to scroll
					//$.scrollify.move('#' + target.attr('id'));
				//} else if(hasNiceScroll) {
				if(hasNiceScroll) {
					// Use nicescroll to scroll
					niceScroll.doScrollTop(target.offset().top-vstone.cache.$header.height(), 1000);
				} else {
					// Use jquery to scroll
					$('html,body').animate({
						scrollTop: target.offset().top-vstone.cache.$header.height()
					}, 1000, 'easeOutExpo');
				}

				// Shouldn't need this if tracking via scrolls
				//var id = '#' + target.attr('id');
				//if(history.pushState) {
				//	history.pushState(null, null, id);
				//} else {
				//	location.hash = id;
				//}
				
			}
		}
	});
	
}







vstone.accordions = function() {
	//console.log('Accordions active.');
	function closeAccordion() {
		$('.accordion-title').removeClass('active');
		$('.accordion-content').slideUp(300).removeClass('open');
	}
	$('.accordion-title').off().on('click',function(e) {
		//console.log('Accordion title clicked.');
		e.preventDefault();
		var accordionID = $(this).attr('href');
		if($(this).hasClass('active')) {
			closeAccordion();
		} else {
			closeAccordion();
			$(this).addClass('active');
			$(accordionID + ' .accordion-content').slideDown(300).addClass('open');
		}
		
		//console.log('Accordion click and scrollifyEnabled: ' + scrollifyEnabled);
		//console.log('Accordion click and hasScrollify: ' + hasScrollify);
		
	//	if (vstone.cache.$body.attr('id') == 'page-partners') {
	//		console.log('Accordion resize');
	//		vstone.cache.$header.length ? headerHeight = vstone.cache.$header.height() : headerHeight = 0;
	//		$('#scrollnav').length ? scrollNavHeight = $('#scrollnav').height() : scrollNavHeight = 0;
	//		offsetHeight = headerHeight + scrollNavHeight;
	//		$('#find-a-stockist').css('height','auto');
	//		$('#find-a-stockist').css('min-height',$(window).height() - offsetHeight);
	//	}
		
		
	});
	$('.accordion-link').off().on('click',function(e) {
		e.preventDefault();
		var accordionID = $(this).attr('href');
		niceScroll.doScrollTop($(accordionID).offset().top - vstone.cache.$header.height() + 1, 1000);
		if(!$(accordionID + ' .accordion-title').hasClass('active')) {	
			closeAccordionSection();
			$(accordionID + ' .accordion-title').addClass('active');
			$(accordionID + ' .accordion-content').slideDown(300).addClass('open');
		}
	});
}





vstone.initShopUI = function() {
	
	
	
	// move these outside of shopui so any page can access them
	
	
	
	
	
	//$('#luxador').on('change.photo', function() {
	//	var $active = $('.product-photo-active','.product-photo-wrap');
	//	var $next = $('.product-photo:nth-child(' + (this.selectedIndex + 1) + ')','.product-photo-wrap');
	//	$active.removeClass('product-photo-active');
	//	$next.addClass('product-photo-active');
	//});
	
	//var selectCallback = function(variant, selector) {
	//	console.log(selector);
	//}
	
	
	
	// HIDING FOR NOW... GOTTA FIX 
	$('.product-photo img')
		.wrap('<span style="display:inline-block"></span>')
		.css('display', 'block')
		.parent()
		.zoom();
		
	//$('.product-photo img').load(function() {
		
		
	//	var imgSrc = $(this).attr('src');
		
	//	console.log('New product image loaded.');
	//	console.log('Image url is: ' + $(this).attr('src'));
		
	//	$(this).zoom({
	//		url: imgSrc
	//	})
		
		//$(this).trigger('zoom.destroy')
		//$(this)
		//	.wrap('<span style="display:inline-block"></span>')
		//	.css('display', 'block')
		//	.parent()
		//	.zoom();
	//});
	
	
	
	
	
	
}

vstone.initPageReveals = function() {
	vstone.cache.$body.addClass('pre-reveal');
	$(window).load(function() {
		$nicescrollCursors = $('.nicescroll-cursors');
		if(vstone.cache.$body.hasClass('template-front')) {
			$scrollNav = $('#scrollnav');
			$direction = $('.direction');
			setTimeout(function () {
				if(mediumViewport) {
					vstone.cache.$footer.css({visibility: 'visible'}).fadeTo(500,1);
					vstone.cache.$sectionBackground.delay(500).css({visibility: 'visible'}).fadeTo(1500,1);
					vstone.cache.$content.delay(1000).css({visibility: 'visible'}).fadeTo(1500,1);
					vstone.cache.$header.delay(1500).css({visibility: 'visible'}).fadeTo(1500,1);
					vstone.cache.$menuButton.delay(1500).css({visibility: 'visible'}).fadeTo(1500,1);
					vstone.cache.$footerWrap.delay(1500).css({visibility: 'visible'}).fadeTo(1500,1);
					$scrollNav.delay(1500).css({visibility: 'visible'}).fadeTo(1500,1);
					$direction.delay(1500).fadeIn(1500);
					vstone.cache.$slideNav.delay(1500).css({visibility: 'visible'}).fadeTo(1500,1);
					$nicescrollCursors.delay(2000).fadeIn(1500);
				} else {
					vstone.cache.$footer.css({visibility: 'visible'}).fadeTo(1000,1);
					vstone.cache.$sectionBackground.css({visibility: 'visible'}).fadeTo(1000,1);
					vstone.cache.$content.css({visibility: 'visible'}).fadeTo(1000,1);
					vstone.cache.$header.css({visibility: 'visible'}).fadeTo(1000,1);
					vstone.cache.$menuButton.css({visibility: 'visible'}).fadeTo(1000,1);
					vstone.cache.$footerWrap.css({visibility: 'visible'}).fadeTo(1000,1);
					$scrollNav.css({visibility: 'visible'}).fadeTo(1000,1);
					$direction.fadeIn(1000);
					vstone.cache.$slideNav.css({visibility: 'visible'}).fadeTo(1000,1);
					$nicescrollCursors.fadeIn(1000);
				}
				vstone.cache.$body.removeClass('pre-reveal');
			}, 500);
		} else {
			setTimeout(function () {	
				if(mediumViewport) {
					vstone.cache.$header.css({visibility: 'visible'}).fadeTo(1500,1);
					vstone.cache.$menuButton.css({visibility: 'visible'}).fadeTo(1500,1);
					vstone.cache.$sectionBackground.delay(500).css({visibility: 'visible'}).fadeTo(1500,1);
					vstone.cache.$content.delay(1000).css({visibility: 'visible'}).fadeTo(1500,1);
					vstone.cache.$footer.delay(1500).css({visibility: 'visible'}).fadeTo(1500,1);
					vstone.cache.$footerWrap.delay(1500).css({visibility: 'visible'}).fadeTo(1500,1);
					$nicescrollCursors.delay(1500).fadeIn(1500);
				} else {
					vstone.cache.$header.css({visibility: 'visible'}).fadeTo(1500,1);
					vstone.cache.$menuButton.css({visibility: 'visible'}).fadeTo(1500,1);
					vstone.cache.$sectionBackground.css({visibility: 'visible'}).fadeTo(1500,1);
					vstone.cache.$content.css({visibility: 'visible'}).fadeTo(1500,1);
					vstone.cache.$footer.css({visibility: 'visible'}).fadeTo(1500,1);
					vstone.cache.$footerWrap.css({visibility: 'visible'}).fadeTo(1500,1);
					$nicescrollCursors.fadeIn(1500);
				}
				vstone.cache.$body.removeClass('pre-reveal');
			}, 200);
		}
	});
}



var niceScroll = false;

vstone.nicescrollScrollified = function() {
	niceScroll = vstone.cache.$body.niceScroll({
		cursorcolor: '#a2a2a2',
		cursoropacitymin: 0.4,
		cursoropacitymax: 1,
		cursorwidth: 12,
		cursorborder: '0 none',
		cursorborderradius: 0,
		zindex: 6000,
		scrollspeed: 80,
		mousescrollstep: 60,
		autohidemode: true,
		spacebarenabled: false,
		horizrailenabled: false,
		enablemousewheel: true, // IF ISSUES... CHANGE TO TRUE
		enablekeyboard: false,
		cursordragspeed: 1.0,

		//touchbehavior: true,
		//nativeparentscrolling: false,
		//cursordragontouch: true,
		
		disablemutationobserver: true
	});
	hasNiceScroll = true;
	
	//var niceScroll = $('body').getNiceScroll()[0];
	//niceScroll.locked = true;
}

vstone.nicescrollDefault = function() {
	niceScroll = vstone.cache.$body.niceScroll({
		cursorcolor: '#a2a2a2',
		cursoropacitymin: 0.4,
		cursoropacitymax: 1,
		cursorwidth: 12,
		cursorborder: '0 none',
		cursorborderradius: 0,
		zindex: 6000,
		scrollspeed: 80,
		mousescrollstep: 60,
		autohidemode: true,
		spacebarenabled: false,
		horizrailenabled: false,
		enablemousewheel: true,
		enablekeyboard: true,
		cursordragspeed: 1.0,
		
		//touchbehavior: true,
		//nativeparentscrolling: false,
		//cursordragontouch: true,
		
		
		disablemutationobserver: true
	});
	hasNiceScroll = true;
	
	//var niceScroll = $('body').getNiceScroll()[0];
	//niceScroll.locked = true;
}




vstone.directionNav = function() {
	
	var $section = $('.section','#main');
	var $len = $section.length;
	var btnDown;
	
	$section.each(function(index) {
		index < $len-1 ? btnDown = '<a href="#' + $(this).next('section').attr('id') + '" class="direction btn-down"></a>' : btnDown = '<a href="#" class="direction btn-down disabled"></a>';
		$(this).append('<div class="direction-nav"><a href="#" class="direction slide-direction slide-prev slide-disabled"></a>' + btnDown + '<a href="#" class="direction slide-direction slide-next slide-disabled"></a></div>');
	});
	
	$('.btn-down').off().on('click.btn-down', function(e) {
		//e.preventDefault();
		//var $target = $('section.section-current').next('section');
		
		var $target = $(this).attr('href');
		console.log($target);
		
		
		//niceScroll.doScrollTop($target.offset().top-$('#header').height(), 1000);
	});
	
}



/* Nicescroll for non-scrollify pages */
vstone.initNiceScroll = function() {
	
	//vstone.nicescrollDefault();
	//vstone.localScroll();

}


/* Global waypoits */
vstone.initWaypoints = function() {

	var waypointBottom = new Waypoint({
		element: vstone.cache.$body,
		handler: function(direction) {
			direction === 'down' ? vstone.cache.$body.addClass('show-footer') : vstone.cache.$body.removeClass('show-footer');
		},
		offset: function() {
			return vstone.winH() - $(document).height() + vstone.cache.$footer.height();
		}
	})
	
	var waypointHeader = new Waypoint({
		element: vstone.cache.$body,
		handler: function(direction) {
			direction === 'up' ? vstone.cache.$body.removeClass('scrolling') : vstone.cache.$body.addClass('scrolling');
		},
		offset: function() {
			var $hero = $('.section-hero');
			var offset;
			$hero.length ? offset = (- $hero.height() -1) : offset = -1;
			return offset;
		}
	})
	
}





vstone.initFlexsliders = function() {
	
	// Maybe make this a template-front-specific function. Or... initSectionSliders (or something like that)?
	//console.log('Flexsliders called');
	
	$.each($('.slider','#main'), function() {	
		
		// Set defaults
		var $slideshow		= false;
		var $slideshowSpeed	= 6000;
		var $animationLoop	= false;
		var $animation		= 'fade';
		var $animationSpeed	= 1000;
		var $initDelay		= 0;
		var $directionNav	= true;
		
		// Replace defaults with data variables if set
		if ($(this).attr('data-slideshow')) $slideshow = $(this).attr('data-slideshow');
		if ($(this).attr('data-slideshow-speed')) $slideshowSpeed = $(this).attr('data-slideshow-speed');
		if ($(this).attr('data-animation-loop')) $animationLoop = $(this).attr('data-animation-loop');
		if ($(this).attr('data-init-delay')) $initDelay = $(this).attr('data-init-delay');

		var slideCount;
		var prevText = '';
		var nextText = '';

		
		// Not in use - doesn't work right yet
		function slideLinks(section,slide,count) {
			console.log('Slide links function called.');
			//$('#flexslider-home .slidecontent').css({opacity: 0, 'margin-left': '10px'});
			//$('#flexslider-home .flex-active-slide .slidecontent').animate({opacity: 1, 'margin-left': 0}, 500);
			//slide == 0 ? prevProj = $('#flexslider-home.flexslider .slides').find('li .project-title').eq(count-1).html() : prevProj = $('#flexslider-home.flexslider .slides').find('li .project-title').eq(slide-1).html();
			//slide == count - 1 ? nextProj = $('#flexslider-home.flexslider .slides').find('li .project-title').eq(0).html() : nextProj = $('#flexslider-home.flexslider .slides').find('li .project-title').eq(slide+1).html();
			
			console.log('This slider section: ' + section.attr('id'));
			console.log('This slider previous: ' + section.find('.slide-prev'));
			console.log('This slider previous length: ' + section.find('.slide-prev').length);
			
			section.find('.slide-prev').html('Test prev');
			section.find('.slide-next').html('Test next');
			//$('#flexslider-home .flex-next').html('<span class="next">' + nextText + '</span><span class="project">' + nextProj + '</span>');		
		}
		
		$(this).flexslider({
			namespace: 'slide-',
			selector: '.slides > .slide',
			animation: 'slide',
			easing: 'easeOutExpo',
			//slideshow: false,
			slideshow: $slideshow,
			initDelay: $initDelay,
			slideshowSpeed: $slideshowSpeed,
			animationSpeed: 1000,
			//animationLoop: false,
			animationLoop: $animationLoop,
			pauseOnAction: true,
			useCSS: false,
			controlNav: true,
			directionNav: true,
			//customDirectionNav: $(this).find('.direction-nav a'),
			customDirectionNav: $(this).find('.slide-direction'),
			manualControls: $(this).find('.slide-nav li'),
			keyboard: false,
			prevText: prevText,
			nextText: nextText,
			start: function(slider) {
				//console.log('Start function this: ' + $(this));
				//slideLinks($(this),slider.currentSlide,slider.count);
			},
			after: function(slider) {
				//console.log('Start function this: ' + $(this));
				//slideLinks($(this),slider.currentSlide,slider.count);
			}
		});
		
	});
	
	//$('.slide-to').on(isMobile ? 'touchend.slider' : 'click.slider', function(e) {
	//$('.slide-to').on(isMobile ? 'touchend.slider' : 'click.slider', function(e) {
	$('.slide-to').on('click', function(e) {
		e.preventDefault();
		var slider = $(this).closest('.slider');
		var target = $(this).data('target-slide') - 1;
		//var target = $(this).attr('href') - 1;
		if(!((typeof slider === 'undefined' || slider === null) && (typeof target === 'undefined' || slider === null))) {
			slider.flexslider(target);
		}
	});
	
	$(document).on('keydown.slider', function(e) {
		var ar = new Array(37, 39);
		var $section = $('.section-current');
		if($section.hasClass('slider') && ($.inArray(e.keyCode, ar) >=0)) {
			e.preventDefault();
			var slideCount = $section.find('.slide').length;
			var slideCurrent = $section.find('.slide-active-slide').index() + 1;
			switch(e.keyCode) {
				case 37:
					if(slideCurrent > 1) $section.flexslider('prev');
					break;
				case 39:
					if(slideCurrent < slideCount) $section.flexslider('next');
					break;
				default: return;
			}
		}
	});
	
}





vstone.contactForms = function() {
	
	// TEMP... THIS CAPTURES POSTED FORMS AND REDIRECTS TO THE RIGHT PAGE SECTION MANUALLY
	// SHOULD BE A FUNCTION THAT GETS CALLED BASED ON PAGE only
	var target = window.location.hash.substr(1);
	//console.log('Hash: ' + target);
	if(target == 'contact_form') {
		console.log('#' + target);
		var parentSection = '#' + $('#' + target).closest('.section').attr('id');
		console.log('Parent section id: ' + parentSection);
		//$.scrollify.instantMove(parentSection);
		//$.scrollify.instantMove('#contact');
		//window.location.hash = '#contact';
		window.location.hash = parentSection;
	}
		
}

vstone.tweets = function() {
	//console.log('Tweets initialized');
	twitterFetcher.fetch({
		id: '720436755263045632', 
		domId: 'tweets'
	});
};

vstone.collectionsIntro = function() {
	
	var blockIntroSibling = null;
	
	$('.collection-wrap').on({
		'mouseenter': function() {
			if (mediumWidth && !isMobile) {
				blockIntroSibling = $(this).siblings();
				if ( !$(this).hasClass('hover') ) {
					$(this).addClass('hover');
				}
				if ( !blockIntroSibling.hasClass('shrink') ) {
					blockIntroSibling.addClass('shrink');
				}
			}
		}, 
		'mouseleave' : function() {
			if (mediumWidth && !isMobile) {
				blockIntroSibling = $(this).siblings();
				if ( $(this).hasClass('hover') ) {
					$(this).removeClass('hover');
				}
				if ( blockIntroSibling.hasClass('shrink') ) {
					blockIntroSibling.removeClass('shrink');
				}
			}
		}
	});
	
}


vstone.animatePageElements = function() {
	
}

vstone.scroll = function(target) {
	
	
	$.scrollify.move(target);
	
}

vstone.scrollNav = function() {
//function attachScrollNav() {
			
			var $section = $('.section','#main');
			
			function fixText(text) {
				return text.replace(/^(.)|\s(.)/g, function($1){ return $1.toUpperCase( ); });
			}
			
			if($section.length > 1) {
				var scrollNavHMTL, linkText;
				scrollNavHTML = '<nav id="scrollnav" class="is-moved-by-drawer" role="navigation"><ul id="scrollnav-links">';
				$section.each(function(index) {
					linkText = $(this).data('section-name');
					if(linkText != undefined) {
						scrollNavHTML += '<li><a class="scrollnav-link" href="#' + this.id + '">' +  fixText(linkText) + '</a></li>';
					}
				});
				scrollNavHTML += '</ul></nav>'

				vstone.cache.$footer.prepend(scrollNavHTML);
	
				Waypoint.refreshAll();
			
				$('.scrollnav-link','#scrollnav').on('click', function(e) {
					e.preventDefault();
					console.log($(this).attr('href'));
					
					vstone.scroll($(this).attr('href'));
					
					//$.scrollify.move($(this).attr('href'));
				});
				
			};
			
		}





vstone.initScrollify = function() {
	
		var $section = $('.section','#main');
		var scrollSpeed = 1000;
		var scrollEasing = 'easeOutExpo'
		//var scrollifyLoaded = 0;


		
		
		/* Fade in elements */
		var fadeInElements = function() {
			if(!vstone.cache.$body.hasClass('pre-reveal')) {
				$('#header-content, #menu-btn, .direction').fadeIn();
			}
		}
		
		/* Hide elements */
		var hideElements = function() {
			if(!vstone.cache.$body.hasClass('pre-reveal')) {
				$('#header-content, #menu-btn, .direction').hide();
			}
		}
		
		/* Show elements */
		var showElements = function() {
			if(!vstone.cache.$body.hasClass('pre-reveal')) {
				$('#header-content, #menu-btn, .direction').show();
			}
		}
		
		
		

		
		
		/* Add 'active' class to scroll nav. */
		var updateScrollNav = function(id) {
			$('li','#scrollnav-links').removeClass('active').find('a[href="#'+id+'"]').parent().addClass('active');
		}
		
		
		var nicescroll = function(scrollified) {
			//vstone.nicescrollDefault();
			vstone.nicescrollScrollified();
			$('.nicescroll-cursors').on('mouseup.scrollify', function() {
					var sectionCurrent = '#' + $('.section-current','#main').attr('id');
					$.scrollify.move(sectionCurrent);
					//$('html, body').animate({scrollTop: $('.section-current').offset().top}, scrollSpeed, scrollEasing);
					//var sectionCurrent;
					//var lastPosition;
					//var newPosition;
					//var interval = setInterval(function() {
					//	newPosition = $('.nicescroll-cursors').css('top');
					//	if(newPosition === lastPosition) {
					//		sectionCurrent = '#' + $('.section-current').attr('id');
					//		$.scrollify.move(sectionCurrent);
					//		clearInterval(interval);
					//	} else {
					//		lastPosition = newPosition;
					//	}
					//}, 50)
					
				});
		}
		

		

		
		
		//var scrollifyOffset = function() {
		//	return $('#main').css('padding-top');
		//}
		//console.log('Scrollify offset: ' + scrollifyOffset());
		
		/* Scrollify settings. */
		var scrollifyOptions = {
			section : '.section',
			sectionName : 'section-name',
			easing: scrollEasing,
			scrollSpeed: scrollSpeed,
			offset : 0,
			//setHeights: false,
			scrollbars: false,
			standardScrollElements: '.no-scrollify',
			afterRender: function() {
				//vstone.initFlexsliders();
				//if($('html').hasClass('touch')) {
				//	$.scrollify.disable(); // NEED TO TURN THIS INTO A FUNCTION THAT DISABLES IT, AND USES DIFFERENT (MANUAL) METHODS FOR DIRECTION AND SCROLL NAV
				//}
				hasScrollify = true;
				
			},
			after: function() {
				// COULD BE USING THIS (AND INDEX OR SECTION ARRAY) TO UPDATE NAVIGATION, ETC... RATHER THAN THE HARD-CODING I'VE CREATED
				//console.log('Waypoints refreshed by scrollify after function.');
				//Waypoint.refreshAll();
			},
			afterResize: function() {
				//scrollifyResize()
				niceScroll.resize();
				Waypoint.refreshAll();
				
			}
		}
		
		
		
		var scrollifyEnable = function() {
			//console.log('New scrollify enable function called.');
			//attachScrollNav();
			$.scrollify(scrollifyOptions);
			nicescroll(false);
			scrollifyEnabled = true;
			//Waypoint.refreshAll();
			
			
		}
		
		
		
		
		
		
		
		
		//if(minScrollifySize()) {
			scrollifyEnable();
		//} else {
		//	scrollifyDisable();
		//}
		
		
		
		
		
		
		
		




		

		
		/* Set current section and update nav links */
		$section.waypoint(function(direction) {
			if (direction === 'down') {
				$(this.element).addClass('section-current').siblings().removeClass('section-current');
				updateScrollNav(this.element.id);
				//if(history.pushState) {
				//	history.pushState(null, null, '#' + this.element.id);
				//} else {
				//	location.hash = '#' + this.element.id;
				//}
			} else {
				$(this.element).prev().addClass('section-current').siblings().removeClass('section-current');
				updateScrollNav($(this.element).prev().attr('id'));
				//if(history.pushState) {
				//	history.pushState(null, null, '#' + $(this.element).prev().attr('id'));
				//} else {
				//	location.hash = '#' + $(this.element).prev().attr('id');
				//}
			}
		}, {offset: '50%'})
		
		
		
		/*
		$('.btn-down').off().on('click.down', function(e) {
			e.preventDefault();
			$.scrollify.next();
		});
		*/
		
		$('a[href*=#]:not(.accordion-title):not([href=#])').off().on('click', function(e) {
			//console.log('Click scroll');
			//console.log('Has accordion class: ' + $(this).hasClass('accordion-title'));
			//if(!$(this).hasClass('accordion-title')) {
				e.preventDefault();
				var $target = $(this).attr('href');
				if ($target.length) {
					$.scrollify.move($target);
				}
			//}
		});
		
		

		
		
		
		/* If template requires scroll navigation, create waypoints */
//		if(scrollNavEnabled) {

			/* Update Scroll Nav Links */
//			$section.waypoint(function(direction) {
//				if (direction === 'down') {
//					updateScrollNav(this.element.id);
//				} else {
//					updateScrollNav($(this.element).prev().attr('id'));
//				}
//			}, {offset: '50%'})
		
			/* Hide/show elements on scroll */
			$section.waypoint(function(direction) {
				// MAKE MIN SCROLLIFY SIZE A VAR THAT I UPDATE RATHER THAN CALLINNG THE FUNCTION (as with subsequent function)
				// LOOK AT THE CONSOLE LOG EVERYTIME I SCROLL OR RESIZE
//				if(scrollifyEnabled && minScrollifySize()) {
				if(mediumViewport) {
					(direction === 'down') ? hideElements() : fadeInElements();
				}
			}, {offset: function() {
					return -30 - vstone.cache.$header.height();
				}
			})

			/* Hide/show elements on scroll */
			$section.waypoint(function(direction) {
//				if(scrollifyEnabled && minScrollifySize()) {
				if(mediumViewport) {
					(direction === 'down') ? fadeInElements() : hideElements();
				}
			}, {offset: function() {
					return 30 + vstone.cache.$header.height();
				}
			})
			
//		}
	
}





$(document).ready(function() {
	
	//console.log('Document ready.');
	//console.log('Doc ready #main height: ' + $('#main').outerHeight());
	//console.log('Doc ready body height: ' + $('body').outerHeight());
	//console.log('Doc ready document height: ' + $(document).outerHeight());
	
	
	//var $winW		= window.innerWidth;
	//var $winH		= window.innerHeight;
	//var $winW		= Waypoint.viewportWidth();
	//var $winH		= Waypoint.viewportHeight();
	
	//console.log('Window is: ' + $winW + ' x ' + $winH)
	
	//var $scrollify		= $('body').hasClass('scrollify') && $isDesktop && vstone.checkMinRes() ? true : false;
	//var $hasTouch		= $('html').hasClass('touch') ? true : false;
	
	//vstone.initEnvironment();
	
	
	
	
	
	
	// Initialize environment
	isMobile = $.browser.mobile;
	isDesktop = $.browser.desktop;
	vstone.cache.$html.hasClass('touch') ? hasTouch = true : hasTouch = false;
	vstone.cache.$body.hasClass('scrollify') ? hasScrollify = true : hasScrollify = false;
	hasScrollify && mediumViewport ? scrollifyEnabled = true : scrollifyEnabled = false;
	vstone.cache.$body.hasClass('template-front') ? templateFront = true : templateFront = false;
	vstone.cache.$body.hasClass('template-shop') ? templateShop = true : templateShop = false;
	isDesktop ? isBGVideoSafe = true : isBGVideoSafe = false;
	//$('body').hasClass('template-front') ? hasScrollNav = true : hasScrollNav = false;
	
	
	// Log environment vars
	console.log('Is mobile: ' + isMobile);
	console.log('Is desktop: ' + isDesktop);
	console.log('Has touch: ' + hasTouch);
	console.log('Has scrollify: ' + hasScrollify);
	console.log('*Scrollify enabled: ' + scrollifyEnabled);
	console.log('Template front: ' + templateFront);
	console.log('Template shop: ' + templateShop);
	console.log('Is background video safe: ' + isBGVideoSafe);
	//console.log('Has scroll nav: ' + hasScrollNav);
	
	
	
	//$('.section').addClass('no-scrollify');
	
	//if(hasScrollify) {
		//vstone.scrollNav();
	//}

	
	

	
	// Cookie-Logout Redirect
	vstone.cache.$customerLogoutLink.on('click', function(e) {
		//e.preventDefault();
		// MUCKED THIS UP A LITTLE...
		var redirect;
		if(vstone.cache.$body.hasClass('template-front')) {
			redirect = false;
		} else {
			redirect = true;
		}
		$.cookie('logout', redirect);
		//console.log('Logout cookie value: ' + $.cookie('logout'));
	});
	  
	// TURN THIS INTO A FUNCTION
	console.log('Logout cookie value: ' + $.cookie('logout'));
	if($.cookie('logout') == 'true') {
	  
		//$.removeCookie('logout');
		//window.location.replace('/collections');

	} else {
		$.removeCookie('logout');
	}
	
	

	
	
	

	
	// Resize handler
	vstone.resizeHandler();
	
	
	
	
	
	
	
	
	// Template Front
	if(templateFront) {
		
		vstone.directionNav();
		vstone.localScroll();
		vstone.scrollNav();
		
		vstone.contactForms();
	}
	
	
	
	
	// Template Shop
	if(templateShop) {
		vstone.initShopUI();
	}
	
	
	
	if(hasScrollify && !hasTouch) {
	//if(hasScrollify) {
		vstone.initScrollify();
	} else {
		vstone.initNiceScroll();
	}
	
	if(scrollifyEnabled) {
		//$.scrollify.disable();
	}
	
	
	
	console.log('DOCUMENT READY');
	
	
	//$('#main-menu').on('click', function() {
	//	console.log('clicked main menu');
	//})
	
	//$('body').on('click', function() {
	//	console.log('clicked body');
	//})
	
	
	// Toggle sub menu states
	vstone.cache.$subMenuToggle.on('click', function() {
		console.log('Sub menu toggle clicked!');
		$(this).parent().siblings().removeClass('sub-menu-open').find('.sub-menu').slideUp(500);
		$(this).parent().toggleClass('sub-menu-open').find('.sub-menu').slideToggle(500);
	});
	
	
	
	
	
	
	//if(isMobile) {
	if(hasScrollify && 1==2) {
		//$.scrollify.disable();
		
		
		// This freezes touchmove! Awesome... use for menu open?
		//document.addEventListener("touchmove", function(e) { e.preventDefault() });
		
		
		
		
		
		//self.scrollInterval = self.$container.is('body') ? window.innerHeight : self.$container.height();
		
		
		
		
		
		
		
		$('.btn-down').off().on('click', function(e) {
			e.preventDefault();
			var $target = $('section.section-current').next('section');
			//console.log($next);
			
			niceScroll.doScrollTop($target.offset().top-vstone.cache.$header.height(), 1000);
			//niceScroll.doScrollTop($target.offset().top, 1000);
		});
		
		$('.scrollnav-link','#scrollnav').off().on('click', function(e) {
			e.preventDefault();
			//var $target = $(this).attr('href');
			//console.log($(this).attr('href'));
			//$.scrollify.move($(this).attr('href'));
			//niceScroll.doScrollTop($target.offset().top-$('#header').height(), 1000);
			
			var $target = $(this.hash);
			
			var $target2 = $(this).attr('href');
			
			
				
				
			$target = $target.length ? $target : $('[name=' + this.hash.slice(1) +']');
			if ($target.length) {
				niceScroll.doScrollTop($target.offset().top-vstone.cache.$header.height(), 1000);
				//niceScroll.doScrollTop($target.offset().top, 1000);
				
				//if(history.pushState) {
				//	history.pushState(null, null, $target2);
				//} else {
				//	location.hash = $target2;
				//}
				
			}
			
			
		});
		
		// add off and "domain"
		$(window).on('resize', function() {
			//console.log(vstone.winH());
			
			vstone.cache.$header.length ? headerHeight = vstone.cache.$header.height() : headerHeight = 0;
			$('#scrollnav').length ? scrollNavHeight = $('#scrollnav').height() : scrollNavHeight = 0;
			offsetHeight = headerHeight + scrollNavHeight;
			
			//console.log('Offset height: ' + offsetHeight);
			
			$('.section').css('height',$(window).height() - offsetHeight);
			
			
		});
		
		
		scrollifyEnabled = false;
	//}
	}
	
	
	
	
	
	
	
	//vstone.videoBGSafe() ? vstone.initBGVideo() : vstone.initMobileVideo();
	vstone.cache.$body.is('#page-home') && isBGVideoSafe ? vstone.initBGVideo() : vstone.initMobileVideo();
	
	
	
	
	vstone.checkSVG();
	
	//if($('body').hasClass('test')) vstone.initScrollifyTest();



	
	
	
	

	
	

	
	
	
	vstone.initFlexsliders()
	
	//$.when(vstone.initFlexsliders()).done(function() {
	//	console.log('Flexsliders initiated!');
		
	//});
	
	
	//vstone.initWaypoints()
	
	
	
	

	
	
	//vstone.initDrawers();
	
	
	
	
	
	//TESTING SWIPE JS... MAY NOT NEED
	//$('html,body').swipe({
	//	swipe:function(event, direction, distance, duration, fingerCount) {
			//event.preventDefault();
	//	}
	//});
	
	//$(function() {
	//	$('body').swipe( {
			//Generic swipe handler for all directions
	//		swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
	//			console.log('You swiped!');
				//$('header').html('Swiped');
				//$(this).text("You swiped " + direction );  
	//		}
	//	});

		//Set some options later
		//$("#test").swipe( {fingers:2} );
	//});

	
	
	
	if($('#tweets').length) {
		vstone.tweets();
	}

	
    
    
	if($('#collections-intro').length) {
		vstone.collectionsIntro();
	}
	
	
	// ADD " autocomplete="off" to form element
	// or don't bother... looks like that won't affect the highlighting color... and i've added html to avoid it all anyway
	//$('.no-auto-fill').
	
	
	$(window).resize( $.debounce('100', function() {
		vstone.resizeHandler();
	}));
	
	
	
	
	//CLUNKY RIGHT NOW?? DUNNO WHY?
	//var drawerScroll = $('#main-menu').niceScroll('.menu-wrap',{
		
	var drawerScroll = $('#main-menuX').niceScroll({
		cursorcolor: '#a2a2a2',
		cursoropacitymin: 0.4,
		cursoropacitymax: 1,
		cursorwidth: 12,
		cursorborder: '0 none',
		cursorborderradius: 0,
		zindex: 6000,
		scrollspeed: 80,
		mousescrollstep: 60,
		autohidemode: true,
		spacebarenabled: false,
		horizrailenabled: false,
		enablemousewheel: true,
		enablekeyboard: true,
		cursordragspeed: 1.0,
		disablemutationobserver: true,
		nativeparentscrolling: false,
		bouncescroll: false
	});
	
	
	

	// Kill scripts if this isn't used
//$('#main-menu').hammer().bind('pan', function(e) {
//	console.log(e.type +" gesture detected.");
//});


	
	
	
	
	//$(document).on('touchmove', function(e){vstone.resizeHandler()});
	
	
    
    //document.addEventListener("touchmove", function(e) { e.preventDefault() });
	

	//$(window).scroll($.debounce( 250, function(){
    //$('.section p').append('DONE!');
		//('.section').height()
		//self.$container.is('body') ? window.innerHeight : self.$container.height();
		//$('html,body').css('height',window.innerHeight);
	//	vstone.resizeHandler();
//}));

	//$('#header').addClass('no-bg');
	
	
	
	
	
	
	// Disable scrollify during print
	// Create function and place accordingly
	if(scrollifyEnabled) {
	
		var beforePrint = function() {
			console.log('Functionality to run before printing.');
			$.scrollify.disable();
		};
		var afterPrint = function() {
			console.log('Functionality to run after printing');
			$.scrollify.enable();
		};
	
		if (window.matchMedia) {
			var mediaQueryList = window.matchMedia('print');
			mediaQueryList.addListener(function(mql) {
			if (mql.matches) {
				beforePrint();
			} else {
				afterPrint();
			}
			});
		}
	
		window.onbeforeprint = beforePrint;
		window.onafterprint = afterPrint;

	}
	
	
	//vstone.initPageReveals();


});
	
$(window).load(function() {
	
	//console.log('Window loaded.');
	vstone.initWaypoints()
	
	//console.log('Window load mediumViewport: ' + mediumViewport);
	
	//if(vstone.cache.$body.hasClass('template-front')) {
	//	var timer = setTimeout(function () {
	//		//$('#overlay').removeClass('loading');
	//		vstone.doPageReveals();
	//		clearTimeout(timer);
	//	}, 500);
	//}
	
	
	
	//vstone.doPageReveals();
	

	

	
});

